// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const BetaCarotene = {
  productCode: "SBOVZ-A ",
  productName: "Beta Carotene",
  ingredients: "Dacus carota, Solanum lycopersicum, Moringa oleifera ",
  overview:" Orgavitaz Provitamin A is an extract blend of organic carrot and moringa leaf processed using SCFE technology to ensure purity, uniform dispersion, superior flowability and stability. The product is standardized for 5% Beta-carotene, a precursor of Vitamin A.",
  assay:" Provitamin-A 5% as Beta Carotene",
  coNutrients:"Carrot based Polyacetylenes retention is relatively higher in Orgavitaz-A and it is positively associated with Beta carotene and Lutein in human lymphoid leukaemia cells. Moringa leaf protein retention is another critical aspect of processing and atleast 7% of the total moringa leaf protein is retained in the process. ",
  studies:"Comprehensive Stability studies, Cell-assays to understand the potential benefits of beta carotene supplementation on macular degeneration.",
  benefits:"OrgaVitaz-A offers a strong anti-oxidant activity as a result of the microenvironment or synergy offered by other secondary metabolites that co-exist. We standardize the food -based complexes with minimal intervention to the co-nutrient profile. Major sources used for production are rich sources of phenolic acids and flavonoids that greatly contributed to their potential antioxidant capacity. ",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/BetaCarotene/BC-1.png",
        "images/Portfolio/OrgavitazForDeficiencies/BetaCarotene/BC-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/BetaCarotene/BC-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/BetaCarotene/BC-4.png",
    "images/Portfolio/OrgavitazForDeficiencies/BetaCarotene/BC-5.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default BetaCarotene;
